import script from "./AccesoPublicoYCorreo.vue?vue&type=script&setup=true&lang=js"
export * from "./AccesoPublicoYCorreo.vue?vue&type=script&setup=true&lang=js"

import "./AccesoPublicoYCorreo.vue?vue&type=style&index=0&id=9b19b1f4&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9b19b1f4"]])

export default __exports__